<template>
  <div id="app" class="o-body-wrap">
    <main class="c-main" id="main" role="main">
      <!-- <complete></complete> -->
      <!-- <home></home> -->
      <!-- <game></game> -->
      
      <home v-if="view == 'default'"></home>
      <game v-if="view == 'riddles'"></game>
      <!-- <complete v-if="view == 'complete'"></complete> -->
      <promotions></promotions>
    </main>
  </div>
</template>

<script>
import Home from '@/pages/Home';
import Game from '@/pages/Game';
// import Complete from '@/pages/Complete';
import Promotions from '@/components/Promotions';

export default {
  name: 'appMain',
  components: {
    home: Home,
    game: Game,
    // complete: Complete,
    promotions: Promotions,
  },
  data() {
    return {
      scrolled: false,
    };
  },
  computed: {
    view() {
      return this.$store.state.view;
    },
  },
};
</script>

<style lang="scss">
  @import "src/stylesheets/index";
</style>



// WEBPACK FOOTER //
// AppMain.vue?2810c2e4